export default clientUuid => `header-${clientUuid}`;
